{
  "version": 1,
  "asset_id": "b93b2c73-23be-4d17-9f7c-869610b8271b",
  "project_id": "7580f3ab-e7a4-418d-abe6-5eb616986e51",
  "url": "/__l5e/assets-v1/b93b2c73-23be-4d17-9f7c-869610b8271b/destination-roofing-galvalume-metal-roof-inverness-fl-768w.webp",
  "r2_key": "a/v1/7580f3ab-e7a4-418d-abe6-5eb616986e51/b93b2c73-23be-4d17-9f7c-869610b8271b/destination-roofing-galvalume-metal-roof-inverness-fl-768w.webp",
  "original_filename": "destination-roofing-galvalume-metal-roof-inverness-fl-768w.webp",
  "size": 115030,
  "content_type": "image/webp",
  "created_at": "2026-07-16T20:37:29Z"
}
